import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { InteractionLogService } from './interaction-log.service';

export const LogEvents = ['click', 'contextmenu', 'dblclick', 'keyup', 'scroll'];

@Directive({
  selector: '[wfmIntLog]'
})
export class InteractionLogDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Input() wfmIntLog: string;

  /**
   * When true, prints the event object.
   *
   * When callback function, calls the callback with wfmIntLog input and event object.
   * Prints the callback result.
   *
   * When object, prints it in the event.
   */
  @Input() wfmIntLogData: boolean | any | ((wfmIntLog: string, event: any) => any) = false;

  @Input() wfmIntLogInclude: string[];

  @Input() wfmIntLogExclude: string[];

  private events: string[] = [];

  constructor(private element: ElementRef, private logService: InteractionLogService) {}

  ngAfterViewInit(): void {
    if (!this.wfmIntLog) {
      throw new Error('wfmIntLog requires a name. No name provided. Usage: <div wfmIntLog="some-name"></div>');
    }

    this.refreshListener();
  }

  ngOnDestroy() {
    this.teardownListeners();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.include || changes.exclude) {
      this.refreshListener();
    }
  }

  private refreshListener() {
    this.teardownListeners();
    this.setEvents();
    this.setUpListeners();
  }

  private setEvents() {
    if (this.wfmIntLogInclude && this.wfmIntLogInclude.length) {
      this.events = this.wfmIntLogInclude;
    } else {
      const exclude = this.wfmIntLogExclude || [];
      this.events = LogEvents.filter(event => exclude.indexOf(event) < 0);
    }
  }

  private setUpListeners() {
    const events = this.events.map(e => e.split('.')[0]).filter((e, i, a) => a.indexOf(e) === i);

    for (const event of events) {
      this.element.nativeElement.addEventListener(event, this.handler);
    }
  }

  private teardownListeners() {
    const events = this.events.map(e => e.split('.')[0]).filter((e, i, a) => a.indexOf(e) === i);

    for (const event of events) {
      this.element.nativeElement.removeEventListener(event, this.handler);
    }
  }

  private handler = (event: Event) => {
    let data: any = undefined;
    if (this.wfmIntLogData) {
      data = (this.wfmIntLogData === true && event) || this.wfmIntLogData;
      if (typeof this.wfmIntLogData === 'function') {
        data = this.wfmIntLogData(this.wfmIntLog, event);
      }
    }
    let eventType = event.type;
    if (eventType.indexOf('key') === 0) {
      const keyCode = (event as KeyboardEvent).code;
      eventType = this.events.find(e => e === `${eventType}.${keyCode}`);
    }
    eventType && this.logService.interactionLog(this.wfmIntLog, eventType, data);
  };
}
